import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import CompanionApp from './companion/CompanionApp';

// Module tournoi BTR Arena — lazy : ne pèse rien sur le companion ('/').
const TournamentApp = lazy(() => import('./tournament/TournamentApp'));

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/tournament/*"
          element={
            <Suspense fallback={<div style={{ minHeight: '100vh', background: '#0B0C10' }} />}>
              <TournamentApp />
            </Suspense>
          }
        />
        {/* Le companion garde la racine (navigation interne par hash). */}
        <Route path="/" element={<CompanionApp />} />
        <Route path="/index.html" element={<CompanionApp />} />
        {/* Toute autre URL : vraie page 404 (au lieu d'afficher l'accueil sans rien dire). */}
        <Route path="*" element={<CompanionApp notFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
